import '../style.css';
import React, { useEffect, useState, useContext } from 'react';
import Button from '../components/utils/Button.jsx'
import { useNavigate, useLocation } from 'react-router-dom'
import { AudioContext } from '../components/utils/AudioContext.jsx'


export default function Map() {
    const navigate = useNavigate();
    const location = useLocation();
    const [buttonsVisible, setButtonsVisible] = useState(false);
    const { playTransi } = useContext(AudioContext);

    useEffect(() => {
        if (location.pathname === '/map') {
            const timer = setTimeout(() => {
                setButtonsVisible(true);
            }, 2000);

            return () => clearTimeout(timer);
        } else {
            setButtonsVisible(false);
        }
    }, [location.pathname]);

    const transi = () => {
        playTransi(); 
    };

    return (
        <>
            <Button position={[70, 18, 56]} text="Routes de campagne" onClick={ () => {navigate('/routescampagne'); playTransi()}} size={460} visible={buttonsVisible}/>
            <Button position={[-400, 18, 268]} text="Autoroute" onClick={ () => {navigate('/autoroute'); playTransi()}} size={440} visible={buttonsVisible}/>
            <Button position={[-320, 18, -80]} text="Ville laboratoire" onClick={ () => {navigate('/villelaboratoire'); playTransi()}} size={420} visible={buttonsVisible}/>
            {/* <Button position={[-200, 18, -315]} text="Périphérique" onClick={ () => {navigate('/')}} size={440} visible={buttonsVisible}/> */}
        </>
    );
}
